import gql from 'graphql-tag';

const MUTATION_DELETE_ESIM = gql`
  mutation deleteEsim($esimId: ID!) {
    deleteEsim(esimId: $esimId) {
      isSuccess
      message
    }
  }
`;

export default MUTATION_DELETE_ESIM;
